(function () {
    'use strict';

    angular
        .module('FormBuilder')
        .directive('fbFieldButtonsWrapper', fbButtonsWrapper);

    function fbButtonsWrapper() {
        return {
            restrict: 'E',
            scope: {
                buttons: '=',
                type: '=',
                name: '=?',
            },
            controller: fbButtonsWrapperCtrl,
            controllerAs: 'vm',
            bindToController:true
        };
    }

    function fbButtonsWrapperCtrl($compile, $templateCache, $element, $scope, FormBuilderHelper) {
        var vm = this;
        this.$onInit = function() {
            vm.formIdentifier = vm.name || $scope.$parent.vm.formIdentifier;

            vm.getElementSize = FormBuilderHelper.getElementSize;

            var templateName = 'common/libraries/formBuilder/buttons-wrapper/button-' + vm.type;
            var template = $templateCache.get(templateName);
            $element.html(template);
            var cloneElement = $compile($element.contents())($scope);

            $scope.$on('$destroy', function() {
                cloneElement.off();
            });
        }
    }
})();
